{
  "religions": {
    "ascrg-code.buddhism": "Buddhism (1511)",
    "ascrg-code.anglican": "Anglican (2511)",
    "ascrg-code.assyrian_apostolic": "Assyrian Apostolic (2512)",
    "ascrg-code.baptist": "Baptist (2513)",
    "ascrg-code.brethren": "Brethren (2514)",
    "ascrg-code.catholic": "Catholic (2515)",
    "ascrg-code.churches_of_christ": "Churches of Christ (2516)",
    "ascrg-code.eastern_orthodox": "Eastern Orthodox (2517)",
    "ascrg-code.jehovah_s_witnesses": "Jehovah's Witnesses (2518)",
    "ascrg-code.latter-day_saints": "Latter-day Saints (2521)",
    "ascrg-code.lutheran": "Lutheran (2522)",
    "ascrg-code.oriental_orthodox": "Oriental Orthodox (2523)",
    "ascrg-code.pentecostal": "Pentecostal (2524)",
    "ascrg-code.presbyterian_and_reformed": "Presbyterian and Reformed (2525)",
    "ascrg-code.salvation_army": "Salvation Army (2526)",
    "ascrg-code.seventh-day_adventist": "Seventh-day Adventist (2527)",
    "ascrg-code.uniting_church": "Uniting Church (2528)",
    "ascrg-code.other_protestant": "Other Protestant (2531)",
    "ascrg-code.other_christian": "Other Christian (2532)",
    "ascrg-code.hinduism": "Hinduism (3511)",
    "ascrg-code.shia": "Shia (4511)",
    "ascrg-code.sunni": "Sunni (4512)",
    "ascrg-code.other_islam": "Other Islam (4513)",
    "ascrg-code.judaism": "Judaism (5511)",
    "ascrg-code.sikhism": "Sikhism (6511)",
    "ascrg-code.australian_aboriginal_traditional_religions": "Australian Aboriginal Traditional Religions (8511)",
    "ascrg-code.baha_i": "Baha'i (8512)",
    "ascrg-code.chinese_religions": "Chinese Religions (8513)",
    "ascrg-code.druse": "Druse (8514)",
    "ascrg-code.japanese_religions": "Japanese Religions (8515)",
    "ascrg-code.nature_religions": "Nature Religions (8516)",
    "ascrg-code.spiritualism": "Spiritualism (8517)",
    "ascrg-code.miscellaneous_religions": "Miscellaneous Religions (8518)",
    "ascrg-code.n_a": "N/A ()",
    "ascrg-code.no_religion": "No Religion (9511)",
    "ascrg-code.secular_beliefs": "Secular Beliefs (9512)",
    "ascrg-code.other_spiritual_beliefs": "Other Spiritual Beliefs (9513)"
  }
}
